import {
    IconCirclePlus,
    IconSend,
    IconMessageCheck,
    IconHandFinger,
    IconCircleX,
    IconShieldCheck,
    IconRefresh,
    IconReceipt,
    IconChecks,
    IconInfoCircle,
} from "@tabler/icons-react";
import type { EventoCotizacionConfig } from "../types/bitacoraCotizacion.types";

/** IDs de com_cat_eventos_cotizacion (deben coincidir con el seeder) */
export const EVENTOS_COTIZACION = {
    CREADA: 1,
    ENVIADA_PROVEEDOR: 2,
    COTIZACION_RESPONDIDA: 3,
    PRODUCTO_SELECCIONADO: 4,
    PRODUCTO_RECHAZADO: 5,
    PRODUCTO_AUTORIZADO: 6,
    PRODUCTO_RECOTIZADO: 7,
    ORDEN_COMPRA_CREADA: 8,
    CONCLUIDA: 9,
} as const; 

/** IDs de com_cat_estatus_cotizacion (deben coincidir con el seeder) */
export const ESTATUS_COTIZACION = {
    CANCELADA: 1,
    ACTIVA: 2,
    CONCLUIDA: 3,
} as const;

export const EVENTO_COTIZACION_CONFIG: Record<number, EventoCotizacionConfig> = {
    [EVENTOS_COTIZACION.CREADA]: { color: "#22b6d1", icon: IconCirclePlus },
    [EVENTOS_COTIZACION.ENVIADA_PROVEEDOR]: { color: "#85b9c2", icon: IconSend },
    [EVENTOS_COTIZACION.COTIZACION_RESPONDIDA]: { color: "#382870", icon: IconMessageCheck },
    [EVENTOS_COTIZACION.PRODUCTO_SELECCIONADO]: { color: "#f6a40e", icon: IconHandFinger },
    [EVENTOS_COTIZACION.PRODUCTO_RECHAZADO]: { color: "#e3818b", icon: IconCircleX },
    [EVENTOS_COTIZACION.PRODUCTO_AUTORIZADO]: { color: "#91e3ab", icon: IconShieldCheck },
    [EVENTOS_COTIZACION.PRODUCTO_RECOTIZADO]: { color: "#cc7533", icon: IconRefresh },
    [EVENTOS_COTIZACION.ORDEN_COMPRA_CREADA]: { color: "#476377", icon: IconReceipt },
    [EVENTOS_COTIZACION.CONCLUIDA]: { color: "#62c396", icon: IconChecks },
};

export const EVENTO_COTIZACION_CONFIG_DEFAULT: EventoCotizacionConfig = {
    color: "#7b809a",
    icon: IconInfoCircle,
};

export const TITULO_COLOR_BITACORA = "#004c93";
export const USUARIO_DESCONOCIDO = "Usuario desconocido";